import { Injectable } from '@angular/core';
import { GenericServicesMotoristaService } from './generic-services-motorista.service';
import { HttpClient } from '@angular/common/http';
import { MensagensService } from 'max-ng-lib';
import {AutorizacaoCheckinFiltro} from '../content/pages/components/autorizacoes/autorizacao-checkin-fora-raio/detalhe-autorizacao-fora/model/autorizacao-checkin-filtro';

@Injectable({ providedIn: 'root' })
export class SolicitacaoService extends GenericServicesMotoristaService {

  constructor(private _mensagensService: MensagensService,
    private _httpClient: HttpClient) {
    super();
  }

  getMensagensService(): MensagensService {
    return this._mensagensService;
  }

  getHttpClient(): HttpClient {
    return this._httpClient;
  }

  getUrlRecurso(): string {
    return '/solicitacao';
  }

  consultarSolicitacao(idSolicitacao: number) {
    return this.get('/consultar', {
      dados: {
        id: idSolicitacao
      }
    });
  }

  solicitacaoCheckinForaRaioAtivo() {
    return this.get('/checkinForaRaioAtivo', {exibirLoading: false});
  }

  autorizarCheckin(idModelo: number, usuario = 1, alterarLocalizacao = true) {
    return this.get('/autorizarCheckin', {
      dados: {
        id: idModelo,
        usuario: usuario,
        alterarLocalizacao: alterarLocalizacao
      }
    });
  }

  reprovarCheckin(idModelo: number, usuario = 1, alterarLocalizacao = false) {
    return this.get('/reprovarCheckin', {
      dados: {
        id: idModelo,
        usuario: usuario,
        alterarLocalizacao: alterarLocalizacao
      }
    });
  }

  autorizarDevolucao(id: any, usuario: number) {
    return this.get('/autorizarDevolucao', {
      dados: {
        id: id,
        usuario: usuario
      }
    });
  }

  reprovarDevolucao(id: any, usuario: number) {
    return this.get('/reprovarDevolucao', {
      dados: {
        id: id,
        usuario: usuario
      }
    });
  }

  getToken(idCliente: any) {
    return this.get('/token', {
      dados: {
        cliente: idCliente
      }
    });
  }

  consultarPorEntregas(idsEntregas: any) {
	  return this.get('/consultarPorEntregas', {
		  dados: {
			  idsEntregas: idsEntregas
		  }
	  });
  }


	pesquisarCheckinForaRaio(filtros: AutorizacaoCheckinFiltro, query: string) {
		return this.post<any>(`/pesquisar?${query}`, {
			dados: filtros
		});
	}
}
